import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login, register, loginWithGoogle } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState("signin");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (mode === "signin") await login(form.email, form.password);
      else await register(form.name, form.email, form.password);
      toast("Welcome to rinova");
      nav("/account");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast(typeof d === "string" ? d : "Something went wrong");
    } finally {
      setBusy(false);
    }
  };

  const cls = "w-full mt-2 bg-transparent border-b border-border py-3 focus:border-black outline-none text-sm";

  return (
    <div data-testid="login-page" className="pt-16">
      <div className="max-w-md mx-auto px-6 pt-24 pb-32">
        <h1 className="font-display text-5xl uppercase text-center mb-3">{mode === "signin" ? "Log In" : "Sign Up"}</h1>
        <p className="caption text-center text-[12px] mb-10">Access your orders, wishlist & saved bag.</p>

        <button data-testid="google-login" onClick={loginWithGoogle}
          className="w-full border border-black py-3.5 product-title text-[12px] link-hover flex items-center justify-center gap-3">
          <span className="font-display text-base normal-case tracking-normal">G</span> Continue with Google
        </button>

        <div className="flex items-center gap-4 my-8">
          <div className="flex-1 h-px bg-border" />
          <span className="util-link text-[10px] caption">or with email</span>
          <div className="flex-1 h-px bg-border" />
        </div>

        <form onSubmit={submit} className="space-y-6">
          {mode === "signup" && (
            <div>
              <label className="util-link text-[11px] caption">Full Name</label>
              <input data-testid="auth-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={cls} />
            </div>
          )}
          <div>
            <label className="util-link text-[11px] caption">Email</label>
            <input data-testid="auth-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={cls} />
          </div>
          <div>
            <label className="util-link text-[11px] caption">Password</label>
            <input data-testid="auth-password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={cls} />
          </div>
          <button data-testid="auth-submit" disabled={busy}
            className="w-full bg-black text-white py-4 product-title text-[13px] link-hover disabled:opacity-50">
            {busy ? "Please wait…" : mode === "signin" ? "Log In" : "Create Account"}
          </button>
        </form>

        <p className="text-center text-[12px] mt-8 caption">
          {mode === "signin" ? "New to rinova? " : "Already have an account? "}
          <button data-testid="auth-toggle" onClick={() => setMode(mode === "signin" ? "signup" : "signin")} className="text-black link-hover underline">
            {mode === "signin" ? "Create an account" : "Log in"}
          </button>
        </p>
      </div>
    </div>
  );
}
